var _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScroll2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none"
    },
    cx: 250.5,
    cy: 250.5,
    r: 197.7
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M114.2,91.1c2.4,2.9,3.5,5.9,3.2,9.2c-0.3,3.3-1.9,6.4-4.8,9.2c-3.2,3.1-6.8,4.5-10.7,4.2 c-3.9-0.4-7.7-2.4-11.4-6.2L89,106c-2.3-2.4-4-4.9-4.9-7.6c-0.9-2.6-1.1-5.2-0.5-7.7c0.6-2.5,2-4.8,4-6.8c2.9-2.8,5.9-4.3,9.2-4.5 c3.3-0.2,6.4,1,9.4,3.5l-5.1,5c-1.7-1.5-3.3-2.2-4.8-2.2c-1.5,0-3,0.8-4.6,2.4c-1.7,1.7-2.4,3.5-2,5.6c0.4,2.1,1.8,4.4,4.3,7 l1.8,1.9c2.6,2.7,5,4.3,7,4.7c2,0.4,3.9-0.2,5.7-1.9c1.6-1.6,2.4-3.1,2.5-4.6c0.1-1.5-0.6-3-2-4.7L114.2,91.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M127.6,88.4l12.3-9l3.4,4.6l-18.1,13.3l-20.6-28.1l5.8-4.2L127.6,88.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M152.8,78.6l-6.2,3.7l-17.8-30l6.2-3.7L152.8,78.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M177.8,53.7c1.3,3.5,1.2,6.8-0.1,9.8c-1.4,3-3.9,5.3-7.7,7c-4.1,1.8-7.9,1.9-11.5,0.2 c-3.6-1.7-6.4-4.9-8.6-9.7l-0.9-1.9c-1.4-3.1-2-6-2-8.8c0-2.8,0.8-5.3,2.2-7.4s3.5-3.8,6.1-5c3.7-1.7,7.1-2,10.2-1 c3.1,1,5.7,3.1,7.6,6.5l-6.5,2.9c-1.1-2-2.3-3.2-3.7-3.7c-1.4-0.5-3.1-0.3-5.1,0.6c-2.2,1-3.5,2.5-3.8,4.6c-0.4,2.1,0.2,4.7,1.6,8 l1.1,2.4c1.5,3.4,3.2,5.7,5,6.8c1.8,1.1,3.8,1.2,6,0.2c2-0.9,3.3-2.1,3.9-3.4c0.6-1.4,0.5-3.1-0.2-5.1L177.8,53.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M192.7,46.9l-2.5,4.9l2.7,9.6l-6.9,1.9l-9.3-33.6l6.9-1.9l4.2,15.2l1.9-5l5.5-13.4l8.5-2.4 l-7.8,18.2l17.4,15.3l-8.2,2.3L192.7,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M249.2,23.3L238.6,24l2,29l-7.2,0.5l-2-29l-10.5,0.7l-0.4-5.8l28.3-1.9L249.2,23.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M283.3,38.2c-0.3,3.4-1.2,6.4-2.6,8.8c-1.4,2.5-3.3,4.3-5.7,5.5c-2.4,1.2-5,1.7-7.9,1.4 c-2.9-0.2-5.4-1.2-7.5-2.7s-3.7-3.7-4.7-6.4c-1-2.7-1.4-5.7-1.1-9l0.1-1.7c0.3-3.4,1.2-6.4,2.6-8.9c1.5-2.5,3.4-4.3,5.7-5.5 c2.4-1.2,5-1.7,7.9-1.4c2.9,0.2,5.4,1.2,7.5,2.7c2.1,1.6,3.7,3.7,4.7,6.4c1,2.7,1.4,5.8,1.1,9.2L283.3,38.2z M276.2,36 c0.3-3.6-0.1-6.5-1.2-8.5s-2.9-3.1-5.3-3.3c-2.4-0.2-4.3,0.6-5.8,2.3c-1.5,1.8-2.4,4.4-2.7,8l-0.1,1.7c-0.3,3.5,0.1,6.3,1.2,8.4 c1.1,2.1,2.9,3.2,5.4,3.4c2.4,0.2,4.3-0.6,5.8-2.4c1.4-1.8,2.3-4.5,2.7-8.1L276.2,36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M317.2,54.6c0.4-1.3,0.2-2.4-0.5-3.4c-0.7-1-2.1-2.2-4.3-3.7s-3.8-2.8-5-4c-3.2-3.2-4.2-6.5-3.1-10 c0.6-1.8,1.6-3.2,3-4.3c1.4-1.1,3.2-1.8,5.4-2c2.1-0.2,4.4,0,6.8,0.8c2.4,0.7,4.4,1.8,6,3.2c1.6,1.4,2.7,3.1,3.2,5 c0.5,1.9,0.5,3.8-0.1,5.8l-6.9-2.1c0.5-1.5,0.4-2.9-0.3-4c-0.7-1.1-1.9-2-3.7-2.5c-1.7-0.5-3.1-0.6-4.2-0.1 c-1.1,0.4-1.9,1.2-2.3,2.4c-0.3,1.1-0.1,2.2,0.8,3.2c0.9,1.1,2.3,2.2,4.2,3.5c3.5,2.4,5.9,4.7,7.2,7c1.3,2.3,1.5,4.7,0.7,7.3 c-0.9,2.9-2.7,4.8-5.4,5.8c-2.7,1-5.9,0.9-9.6-0.2c-2.6-0.8-4.8-2-6.6-3.6c-1.8-1.6-3-3.4-3.6-5.3c-0.6-2-0.6-4,0.1-6.2l6.9,2.1 c-1.1,3.7,0.5,6.2,4.9,7.5c1.6,0.5,3,0.6,4.1,0.2C316.1,56.6,316.8,55.8,317.2,54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M354.4,68.2c-1.9,3.3-4.4,5.3-7.6,6.2c-3.2,0.9-6.6,0.4-10.3-1.4c-4-1.9-6.5-4.8-7.5-8.6 c-1-3.8-0.4-8.1,1.9-12.8l0.9-1.9c1.5-3,3.3-5.4,5.4-7.2c2.2-1.8,4.5-2.8,7.1-3.1c2.6-0.3,5.2,0.2,7.8,1.5 c3.6,1.7,6.1,4.1,7.4,7.1c1.3,3,1.2,6.3-0.1,10l-6.5-3.1c0.8-2.1,1-3.8,0.4-5.2c-0.5-1.4-1.8-2.5-3.8-3.5c-2.2-1-4.1-1-6,0 c-1.8,1-3.5,3.2-5.1,6.4l-1.1,2.4c-1.6,3.4-2.3,6.1-2,8.2c0.3,2.1,1.5,3.6,3.7,4.7c2,1,3.7,1.2,5.1,0.8c1.4-0.4,2.7-1.6,3.7-3.4 L354.4,68.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M370.2,77.3l-4.7-3.2l-7.2,10.5l-5.9-4.1l19.8-28.7l10.7,7.3c3.4,2.3,5.5,4.9,6.3,7.7 c0.8,2.8,0.2,5.5-1.7,8.3c-1.3,2-2.9,3.3-4.6,4c-1.7,0.7-3.8,0.9-6,0.5l-1.9,16l-0.2,0.3l-6.3-4.4L370.2,77.3z M368.8,69.3 l4.8,3.3c1.5,1,2.9,1.4,4.2,1.2c1.3-0.2,2.5-1,3.4-2.3c0.9-1.4,1.3-2.7,1-4c-0.2-1.3-1.1-2.5-2.7-3.6l-4.8-3.3L368.8,69.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M409,105.5c-2.4,2.5-4.9,4.2-7.5,5.3c-2.7,1-5.3,1.3-7.9,0.7c-2.6-0.5-5-1.8-7.1-3.8 c-2.1-2-3.5-4.3-4.2-6.8c-0.7-2.6-0.6-5.2,0.3-7.9c0.9-2.7,2.5-5.3,4.8-7.7l1.2-1.2c2.4-2.5,4.9-4.2,7.6-5.3 c2.7-1,5.3-1.3,7.9-0.7c2.6,0.5,4.9,1.8,7,3.8c2.1,2,3.5,4.3,4.2,6.9c0.7,2.6,0.6,5.2-0.4,8c-0.9,2.7-2.5,5.3-4.9,7.8L409,105.5z  M404.9,99.3c2.5-2.6,4-5.1,4.3-7.4c0.4-2.3-0.3-4.3-2.1-5.9c-1.7-1.7-3.7-2.3-6-1.8s-4.6,2-7.1,4.6l-1.2,1.2 c-2.5,2.6-3.9,5-4.3,7.3c-0.4,2.3,0.3,4.3,2.1,6c1.7,1.7,3.7,2.3,6,1.8c2.2-0.5,4.6-2,7.1-4.6L404.9,99.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M409,122.9l9.4,12l-4.5,3.5L400,120.7l27.5-21.4l4.4,5.7L409,122.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M424,144.3l7.8,13.1l-5,2.9L415.4,141l30-17.8l3.7,6.2L424,144.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M445.6,161.7c1-0.4,2-0.5,2.9-0.1c0.9,0.4,1.6,1.1,2.1,2.2c0.4,1,0.5,2,0.2,3c-0.3,1-1,1.6-2,2.1 c-1,0.4-2,0.4-2.9,0s-1.6-1.1-2-2.2c-0.5-1.1-0.5-2.1-0.2-3C444,162.8,444.7,162.1,445.6,161.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M456.2,208.8c-3.7,0.7-6.9,0.2-9.6-1.6c-2.7-1.8-4.7-4.7-5.7-8.7c-1.2-4.3-0.7-8.1,1.5-11.4 c2.2-3.3,5.9-5.6,10.9-7l2.1-0.6c3.2-0.9,6.2-1.1,9-0.7s5.1,1.6,7,3.3s3.2,4,4,6.8c1.1,3.9,0.9,7.3-0.5,10.2 c-1.4,2.9-4,5.1-7.6,6.5l-1.9-6.9c2.1-0.8,3.5-1.8,4.2-3.1c0.7-1.3,0.7-3,0.2-5.1c-0.6-2.3-1.9-3.8-3.9-4.5 c-2-0.7-4.7-0.6-8.2,0.4l-2.5,0.7c-3.6,1-6.1,2.3-7.5,3.8c-1.4,1.6-1.7,3.5-1.1,5.9c0.6,2.1,1.5,3.6,2.8,4.4c1.3,0.8,2.9,1,5,0.6 L456.2,208.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M452.7,227.2l1.5,15.2l-5.7,0.6l-2.2-22.3l34.7-3.5l0.7,7.1L452.7,227.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M448.2,253.8l0-7.2l34.8,0l0,7.2L448.2,253.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M456.9,288c-3.7-0.7-6.5-2.4-8.3-5.1c-1.9-2.7-2.6-6.1-2.1-10.2c0.5-4.4,2.4-7.8,5.7-10 c3.3-2.2,7.5-3,12.7-2.4l2.1,0.2c3.3,0.4,6.2,1.3,8.6,2.8c2.4,1.5,4.2,3.4,5.3,5.7c1.1,2.3,1.5,4.9,1.2,7.8 c-0.5,4-1.9,7.1-4.3,9.3c-2.4,2.2-5.6,3.3-9.5,3.2l0.8-7.1c2.3,0.1,3.9-0.4,5.1-1.3c1.1-1,1.8-2.5,2.1-4.7c0.3-2.4-0.4-4.3-2-5.6 c-1.6-1.4-4.1-2.3-7.7-2.7l-2.6-0.3c-3.7-0.4-6.5-0.2-8.4,0.8c-1.9,0.9-2.9,2.6-3.2,5.1c-0.2,2.2,0.1,3.9,1,5.1s2.4,2,4.5,2.4 L456.9,288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M455.2,304.3l-2.9-4.7l-9.6-2.6l1.9-6.9l33.6,9.1l-1.9,6.9l-15.2-4.1l3.4,4.2l8.8,11.6l-2.3,8.5 l-11.7-16l-22,7.2l2.2-8.2L455.2,304.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M446.8,365l4.8-9.5l-25.9-13l3.2-6.4l25.9,13l4.7-9.4l5.2,2.6L452,367.6L446.8,365z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M416.6,386.8c-2.8-2-4.9-4.2-6.3-6.7c-1.4-2.5-2-5.1-1.9-7.7c0.2-2.7,1.1-5.2,2.8-7.5 c1.7-2.4,3.7-4.1,6.2-5.1c2.4-1,5.1-1.3,7.9-0.8c2.8,0.5,5.6,1.7,8.3,3.6l1.4,1c2.8,2,4.9,4.2,6.3,6.8c1.4,2.5,2,5.1,1.9,7.8 c-0.2,2.6-1.1,5.2-2.8,7.5c-1.7,2.4-3.7,4.1-6.2,5.1c-2.4,1-5.1,1.3-7.9,0.8c-2.8-0.5-5.7-1.7-8.4-3.7L416.6,386.8z M422.2,381.8 c3,2.1,5.6,3.2,7.9,3.2c2.3,0,4.2-0.9,5.6-2.9c1.4-2,1.7-4,0.9-6.2c-0.8-2.2-2.6-4.3-5.6-6.4l-1.4-1c-2.9-2.1-5.5-3.1-7.9-3.2 c-2.4-0.1-4.2,0.9-5.7,2.9c-1.4,2-1.7,4-0.9,6.2c0.8,2.1,2.7,4.3,5.6,6.4L422.2,381.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M385.2,407.6c0.9,1,2,1.5,3.2,1.3c1.2-0.1,3-0.7,5.4-1.8c2.4-1.1,4.4-1.8,6-2.2 c4.4-1.1,7.8-0.3,10.2,2.4c1.3,1.4,2,3,2.2,4.8c0.2,1.8-0.1,3.7-1.1,5.6s-2.3,3.8-4.1,5.4c-1.8,1.7-3.8,2.8-5.8,3.5 c-2,0.6-4,0.7-5.9,0.2c-1.9-0.5-3.6-1.5-5-3.1l5.3-4.8c1.1,1.2,2.3,1.8,3.6,1.7c1.3,0,2.7-0.6,4-1.9c1.3-1.2,2.1-2.4,2.3-3.6 s-0.1-2.3-0.9-3.2c-0.8-0.8-1.8-1.2-3.2-1s-3.1,0.8-5.2,1.8c-3.8,1.8-7.1,2.7-9.7,2.6c-2.6-0.1-4.8-1.1-6.6-3.1 c-2-2.2-2.8-4.7-2.2-7.6c0.5-2.8,2.2-5.5,5.1-8.1c2-1.8,4.1-3.1,6.4-3.8c2.3-0.8,4.4-0.9,6.4-0.4c2,0.5,3.8,1.6,5.3,3.2l-5.3,4.8 c-2.6-2.8-5.6-2.7-9,0.4c-1.3,1.1-2,2.3-2.3,3.5C384.1,405.6,384.4,406.6,385.2,407.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M354.5,432.7c-1.9-3.3-2.3-6.5-1.5-9.7c0.9-3.2,3-5.9,6.4-8.2c3.7-2.5,7.5-3.2,11.3-2.1 c3.8,1.1,7.2,3.8,10.1,8.2l1.2,1.8c1.9,2.8,3,5.6,3.4,8.3c0.4,2.8,0.1,5.3-1,7.7s-2.8,4.3-5.2,5.9c-3.3,2.2-6.6,3.1-9.9,2.7 c-3.2-0.4-6.1-2.2-8.6-5.2l6-4c1.4,1.8,2.8,2.8,4.3,3s3.1-0.2,4.9-1.5c2-1.3,3-3,3-5.1c0-2.1-0.9-4.6-2.9-7.7l-1.5-2.2 c-2.1-3.1-4.1-5.1-6-5.9c-1.9-0.8-3.9-0.5-5.9,0.8c-1.8,1.2-2.9,2.6-3.3,4c-0.3,1.4,0,3.1,1,5L354.5,432.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M338.7,441.6l5.2-2.4l-5.4-11.6l6.5-3l14.7,31.6l-11.7,5.5c-3.7,1.7-7,2.2-9.8,1.5 c-2.8-0.7-4.9-2.6-6.3-5.6c-1-2.2-1.4-4.2-1.1-6c0.3-1.9,1.1-3.7,2.6-5.4l-12.8-9.7l-0.1-0.3l7-3.2L338.7,441.6z M346.3,444.5 l-5.3,2.4c-1.6,0.8-2.7,1.8-3.2,3c-0.5,1.2-0.4,2.6,0.2,4.1c0.7,1.5,1.7,2.5,2.9,2.9c1.2,0.5,2.7,0.3,4.5-0.5l5.2-2.4L346.3,444.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M294.7,460.8c-0.9-3.3-1.2-6.4-0.7-9.2c0.5-2.8,1.6-5.2,3.4-7.2c1.8-2,4.1-3.4,6.9-4.1 c2.8-0.8,5.4-0.8,8-0.1c2.6,0.7,4.8,2.1,6.7,4.3c1.9,2.1,3.3,4.8,4.2,8l0.5,1.7c0.9,3.3,1.2,6.4,0.7,9.2c-0.5,2.8-1.6,5.2-3.4,7.2 c-1.8,2-4.1,3.3-6.9,4.1c-2.8,0.8-5.5,0.8-8,0.1s-4.8-2.2-6.7-4.3c-1.9-2.2-3.3-4.9-4.3-8.2L294.7,460.8z M302.1,460.3 c1,3.5,2.4,6,4.2,7.5c1.8,1.5,3.8,1.9,6.2,1.2c2.3-0.7,3.8-2.1,4.6-4.2c0.7-2.2,0.6-5-0.3-8.5l-0.5-1.6c-1-3.4-2.4-5.9-4.2-7.4 s-3.9-2-6.2-1.3c-2.3,0.7-3.8,2.1-4.6,4.2c-0.7,2.2-0.6,5,0.4,8.5L302.1,460.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M279.8,451.9l-15.1,2l-0.7-5.7l22.2-2.9l4.5,34.5l-7.1,0.9L279.8,451.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M253.7,454l-15.2,0l0-5.8l22.4,0l0,34.8l-7.2,0L253.7,454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M227.7,463.7c-0.1,1.1-0.6,1.9-1.4,2.5c-0.8,0.6-1.8,0.8-2.9,0.7s-2-0.6-2.7-1.4 c-0.6-0.8-0.9-1.7-0.8-2.8c0.1-1.1,0.6-1.9,1.5-2.5s1.8-0.8,2.9-0.7c1.1,0.1,2,0.6,2.7,1.4C227.6,461.7,227.8,462.7,227.7,463.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M181.8,448.7c1.2-3.5,3.3-6,6.3-7.5s6.4-1.6,10.4-0.5c4.3,1.2,7.3,3.5,9,7.1 c1.7,3.6,1.8,7.9,0.5,13l-0.6,2.1c-0.9,3.2-2.2,5.9-4,8.1s-3.9,3.6-6.4,4.3c-2.5,0.7-5.1,0.7-7.9,0c-3.9-1.1-6.7-2.9-8.5-5.7 c-1.8-2.7-2.4-6-1.7-9.9l6.9,1.9c-0.4,2.2-0.2,4,0.5,5.2s2.2,2.2,4.3,2.8c2.3,0.6,4.3,0.3,5.9-1.1s2.9-3.8,3.9-7.2l0.7-2.5 c1-3.6,1.2-6.4,0.5-8.4s-2.2-3.3-4.5-3.9c-2.1-0.6-3.9-0.5-5.2,0.2c-1.3,0.7-2.3,2-3,4L181.8,448.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M167.8,436.4l-13.8-6.4l2.4-5.2l20.4,9.4l-14.6,31.6l-6.5-3L167.8,436.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M147,419l6.2,3.6l-17.7,30l-6.2-3.6L147,419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M113.2,409.1c2.5-2.8,5.4-4.4,8.6-4.6c3.3-0.2,6.6,0.9,9.8,3.4c3.6,2.7,5.5,6,5.7,9.9 c0.2,3.9-1.2,8-4.4,12.2l-1.3,1.7c-2,2.7-4.3,4.7-6.7,6c-2.5,1.3-5,1.9-7.6,1.6c-2.6-0.2-5-1.2-7.3-3c-3.2-2.4-5.2-5.2-5.8-8.4 c-0.7-3.2,0-6.5,2.1-9.8l5.7,4.3c-1.2,1.9-1.7,3.6-1.4,5c0.3,1.5,1.3,2.8,3,4.2c1.9,1.4,3.9,1.8,5.8,1.2c2-0.7,4.1-2.4,6.3-5.3 l1.6-2.1c2.3-3,3.5-5.5,3.6-7.6c0.1-2.1-0.8-3.8-2.7-5.3c-1.8-1.3-3.4-1.9-4.9-1.8c-1.5,0.2-2.9,1-4.3,2.6L113.2,409.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M100,399.4l5.5-0.1l7.1-6.9l5,5.1l-25,24.3l-5-5.1l11.3-11l-5.3,0.8L79.3,408l-6.2-6.3l19.7-1.9 l5-22.6l6,6.1L100,399.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M52.2,361.2l5.8,9l24.4-15.7l3.9,6l-24.4,15.7l5.7,8.9l-4.9,3.1l-15.3-23.9L52.2,361.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M48.7,324.2c3.1-1.4,6.1-2.1,9-2c2.9,0.1,5.4,0.8,7.6,2.3c2.2,1.5,3.9,3.6,5.1,6.2 c1.2,2.6,1.6,5.3,1.2,7.9s-1.4,5-3.3,7.2c-1.8,2.2-4.3,4-7.3,5.3l-1.6,0.7c-3.1,1.4-6.1,2.1-9,2c-2.9-0.1-5.4-0.8-7.6-2.3 c-2.2-1.5-3.9-3.6-5.1-6.2c-1.2-2.7-1.6-5.3-1.2-7.9c0.4-2.6,1.5-5,3.3-7.2c1.9-2.2,4.4-4,7.5-5.4L48.7,324.2z M50.2,331.5 c-3.3,1.5-5.6,3.2-6.8,5.2c-1.2,2-1.3,4.1-0.3,6.3c1,2.2,2.6,3.5,4.8,3.9c2.2,0.4,5-0.1,8.3-1.5l1.6-0.7c3.2-1.5,5.5-3.2,6.8-5.2 c1.3-2,1.4-4.1,0.4-6.4c-1-2.2-2.6-3.5-4.9-3.9s-5,0.1-8.3,1.6L50.2,331.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M46.7,286.6c-1.3,0.3-2.2,1-2.8,2c-0.5,1.1-0.9,2.9-1.2,5.5c-0.3,2.6-0.7,4.7-1.1,6.3 c-1.3,4.3-3.7,6.8-7.2,7.6c-1.8,0.4-3.6,0.2-5.3-0.5c-1.7-0.7-3.1-2-4.3-3.8c-1.2-1.8-2.1-3.9-2.6-6.3c-0.5-2.4-0.5-4.7,0-6.8 c0.5-2.1,1.4-3.8,2.8-5.2c1.4-1.4,3.1-2.3,5.2-2.7l1.5,7c-1.6,0.3-2.7,1.1-3.3,2.2c-0.7,1.2-0.8,2.6-0.4,4.4c0.4,1.7,1,3,1.9,3.8 c0.9,0.8,2,1.1,3.2,0.8c1.1-0.2,1.9-1,2.4-2.3s0.9-3.1,1.1-5.4c0.4-4.2,1.3-7.5,2.7-9.7s3.4-3.6,6.1-4.1c3-0.6,5.5,0,7.6,1.9 c2.1,1.9,3.6,4.7,4.4,8.5c0.5,2.6,0.6,5.1,0.1,7.5c-0.5,2.4-1.5,4.3-2.9,5.8c-1.4,1.5-3.3,2.5-5.5,2.9l-1.5-7.1 c3.8-0.8,5.2-3.4,4.2-7.9c-0.3-1.7-1-2.9-1.8-3.7S47.9,286.3,46.7,286.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M40.7,247.4c3.8,0.1,6.8,1.3,9.1,3.7c2.3,2.4,3.5,5.6,3.8,9.7c0.2,4.5-1.1,8-3.9,10.8 c-2.9,2.7-6.9,4.2-12.2,4.5l-2.1,0.1c-3.3,0.2-6.3-0.3-8.9-1.3c-2.6-1-4.7-2.6-6.1-4.7c-1.5-2.1-2.3-4.6-2.5-7.5 c-0.2-4,0.7-7.3,2.7-9.9s5-4.1,8.8-4.7l0.4,7.2c-2.2,0.3-3.8,1-4.8,2.1c-1,1.1-1.4,2.8-1.3,5c0.1,2.4,1.1,4.1,2.9,5.2 c1.8,1.1,4.5,1.6,8.1,1.4l2.6-0.1c3.8-0.2,6.5-0.9,8.2-2.2c1.7-1.2,2.4-3.1,2.3-5.5c-0.1-2.2-0.7-3.8-1.8-4.9 c-1.1-1-2.7-1.6-4.8-1.6L40.7,247.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M41.1,229.2l-0.6,5.7l12.7,1.3l-0.7,7.1l-34.7-3.5l1.3-12.9c0.4-4.1,1.6-7.2,3.7-9.2 s4.7-2.9,8.1-2.5c2.4,0.2,4.3,1,5.8,2.1c1.5,1.2,2.6,2.9,3.3,5l14.9-6.1l0.3,0l-0.8,7.7L41.1,229.2z M34.8,234.3l0.6-5.8 c0.2-1.8-0.1-3.2-0.9-4.3c-0.8-1.1-2-1.7-3.6-1.9c-1.6-0.2-3,0.2-4,1c-1,0.8-1.6,2.2-1.8,4.1l-0.6,5.7L34.8,234.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M47.1,181.6c3.3,0.9,6.1,2.3,8.2,4.1c2.2,1.8,3.7,4,4.4,6.6s0.8,5.2,0,8c-0.7,2.8-2.1,5.1-4,6.9 c-1.9,1.8-4.3,3-7.1,3.5c-2.8,0.5-5.8,0.4-9.1-0.5l-1.7-0.4c-3.3-0.9-6.1-2.3-8.3-4.1s-3.7-4.1-4.4-6.6c-0.8-2.5-0.8-5.2,0-8 c0.8-2.8,2.1-5.1,4-6.9c1.9-1.8,4.3-3,7.2-3.5c2.8-0.5,5.9-0.3,9.2,0.5L47.1,181.6z M43.7,188.2c-3.5-0.9-6.4-1-8.5-0.3 c-2.2,0.8-3.6,2.3-4.2,4.7c-0.6,2.3-0.2,4.4,1.3,6.1c1.5,1.7,4,3.1,7.4,4.1l1.6,0.4c3.4,0.9,6.3,1,8.5,0.3 c2.2-0.8,3.7-2.3,4.3-4.7c0.6-2.3,0.2-4.4-1.3-6.1c-1.5-1.7-4-3.1-7.5-4L43.7,188.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M62.2,173.3l6-14l5.3,2.3l-8.8,20.6l-32-13.7l2.8-6.6L62.2,173.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M73.7,149.7l7.7-13.1l5,2.9L75,158.8l-30-17.7l3.6-6.2L73.7,149.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M78.5,122.4c-0.9-0.7-1.4-1.5-1.4-2.5c-0.1-1,0.2-1.9,0.9-2.8c0.7-0.9,1.5-1.4,2.5-1.6 c1-0.2,1.9,0.1,2.8,0.8c0.9,0.7,1.3,1.5,1.4,2.5c0.1,1-0.2,2-0.9,2.8c-0.7,0.9-1.6,1.4-2.5,1.6C80.3,123.3,79.4,123.1,78.5,122.4z "
  })), /*#__PURE__*/React.createElement("path", {
    id: "Circle_x5F_2",
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    d: "M401.4,360.2 c23.2-31.9,35.7-70.3,35.7-109.7c0-102.4-84.2-186.6-186.6-186.6S63.9,148.1,63.9,250.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_3"
  }, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 3,
      strokeMiterlimit: 10
    },
    x1: 163.8,
    y1: 163.3,
    x2: 337.2,
    y2: 336.7
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 336.9,
    y1: 276.3,
    x2: 336.9,
    y2: 336.4
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 276.9,
    y1: 336.4,
    x2: 336.9,
    y2: 336.4
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScroll2);
export default __webpack_public_path__ + "static/media/scroll_2.8cb7eea7e214b20f30438c27abc223a5.svg";
export { ForwardRef as ReactComponent };